import React from 'react';
import ToggleComponent from "v4/components/utils/ToggleComponent/ToggleComponent";
import {SearchProvider} from "v4/contexts/SearchContext/SearchContext";
import {MAIL_TYPE_SEARCH} from "v4/data/apiRoutes";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import MailsTypesAdd from "v4/pages/front/MailsTypes/components/MailsTypesAdd/MailsTypesAdd";
import MailsTypesEdit from "v4/pages/front/MailsTypes/components/MailsTypesEdit/MailsTypesEdit";
import MailsTypesListing from "v4/pages/front/MailsTypes/components/MailsTypesListing/MailsTypesListing";
import useHashPulse from "v4/hooks/useHashPulse";

/* TODO: Setup done but finish when there will be the routes */
export default function MailsTypesPage() {
    const {currentRoute} = useNavigation();
    const {routeType, params} = currentRoute;
    const isAddPage = routeType === 'ADD';
    const isEditPage = routeType === 'EDIT';
    const isListingShowing = !(isAddPage || isEditPage);
    const mailTypeId = params?.mailType;
    useHashPulse(isListingShowing);

    return (
        <>
            <SearchProvider searchRouteName={MAIL_TYPE_SEARCH} pageType="mailTypes">
                <ToggleComponent isShowing={isListingShowing} className="page page-list main-content__body__slide">
                    <MailsTypesListing/>
                </ToggleComponent>
            </SearchProvider>

            {isAddPage && <MailsTypesAdd/>}
            {isEditPage && <MailsTypesEdit mailTypeId={mailTypeId}/>}
        </>
    );
}
